import {Component, OnInit} from '@angular/core';
import {PlanService} from "../../services/plan.service";
import {CreatePlanDto} from "../../dto/create-plan.dto";
import {ModalController} from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent } from "@ionic/angular/standalone";
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SexyModule} from '@qid/sexy';
import {SuperButtonComponent, SuperInputComponent} from '@qid/super';

@Component({
  selector: 'app-create-plan',
  templateUrl: './create-plan.page.html',
  styleUrls: ['./create-plan.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    SuperInputComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent
  ]
})
export class CreatePlanPage implements OnInit {

  public createPlanDto: CreatePlanDto = new CreatePlanDto();

  constructor(private planService: PlanService,
              private modalController: ModalController
  ) {
  }

  ngOnInit() {
  }

  create = async () => {
    const res = await this.planService.create(this.createPlanDto);
    if (!res || res.errorMessage) {
      throw res.errorMessage;
    }
    if (res && res.data) {
      this.modalController.dismiss({
        plan: res.data
      })
    }
  }

  close() {
    this.modalController.dismiss()
  }
}
